import { ca } from '@cian/analytics';
import { mergeStyles } from '@cian/components';
import { parseCookies } from '@cian/utils';
import { setCookie } from '@cian/utils/lib/browser/cookie';
import * as React from 'react';
import { connect } from 'react-redux';

import { Button } from '../../../common/components/button';
import { IAppState } from '../../../common/state/app_state';
import { IJsonQuery } from '../../../json_query';
import { SavePopupContainer } from './popup/container';
import { IconSearch } from './search_icon';
import {
  trackingShowSaveOnNarrow,
  trackingShowSaveOnWide,
  trackSaveButtonClick,
  trackSaveButtonWithAdvancedFilterClick,
} from './tracking';
import { isNewbuildingGkButtonExperiment } from '../filters/ab/newbuilding_gk_button/index';

const style = require('./index.css');

export interface ISaveProps {
  isAdvancedFiltersOpened?: boolean;
  jsonQuery: IJsonQuery;
  isAuthenticated: boolean;
  small?: boolean;
  resultsJsonQuery: IJsonQuery;
  newbuildingGkButtonExperiment: boolean;
  queryString?: string;
  //свойства для эксперимента с яркой кнопкой сохранить CD-43359
  text?: string;
  mode?: 'light' | 'outline';
  className?: string;
}

export interface ISaveState {
  isPopupVisible: boolean;
  isSmallVersion?: boolean;
  isAnimated: boolean;
}

const smallSize = 992;

export class Save extends React.Component<ISaveProps, ISaveState> {
  public constructor(props: ISaveProps) {
    super(props);

    this.state = {
      isPopupVisible: false,
      isAnimated: false,
    };
  }

  public componentDidMount() {
    document.addEventListener('resize', this.handleResize);

    this.setState({
      isSmallVersion: window.innerWidth <= smallSize,
    });
  }

  public componentWillReceiveProps(nextProps: ISaveProps) {
    if (this.props.mode !== nextProps.mode && nextProps.mode === 'light') {
      this.setState({
        isAnimated: false,
      });
    }

    if (this.props.resultsJsonQuery !== nextProps.resultsJsonQuery) {
      const isAnimationPlayed = Boolean(parseCookies(document.cookie)['save_search_animation_done']);

      if (isAnimationPlayed) {
        this.setState({
          isAnimated: false,
        });

        return;
      }

      if (!isAnimationPlayed) {
        this.setState({
          isAnimated: true,
        });

        ca('event', {
          name: 'oldevent',
          category: 'Listing',
          action: 'pulse_saved_search',
          label: '',
        });

        setCookie('save_search_animation_done', 'rawr', {
          secure: false,
          expires: 60 * 24 * 30, // 30 дней
        });
      }
    }
  }

  public componentWillUnmount() {
    document.removeEventListener('resize', this.handleResize);
  }

  public render() {
    const { isAnimated } = this.state;
    const { newbuildingGkButtonExperiment, small, mode, queryString, text = 'Сохранить' } = this.props;
    //не нужно анимировать кнопку когда мы в эксперименте и она не активна
    const isFromSavedSearch = queryString && queryString.includes('saved_search_id');

    return (
      <div {...mergeStyles(style['container'], style['hover-hint'])}>
        <Button
          theme="primary"
          mode={mode}
          size="small"
          {...mergeStyles(
            style['button'],
            isAnimated && mode !== 'light' && !isFromSavedSearch && style['heartbeat'],
            (small || newbuildingGkButtonExperiment) && style['button--hideText'],
            this.props.className,
          )}
          onClick={this.openPopup}
        >
          <span className={style['icon-container']}>
            <IconSearch />
          </span>
          <span className={style['button-text']}>{text}</span>
        </Button>
        {this.state.isPopupVisible && (
          <SavePopupContainer
            onClose={this.handlePopupClose}
            isAdvancedFiltersOpened={this.props.isAdvancedFiltersOpened}
          />
        )}
      </div>
    );
  }

  private handleResize() {
    const isSmallVersion = window.innerWidth <= smallSize;

    if (this.state.isSmallVersion !== isSmallVersion) {
      this.setState({ isSmallVersion });
    }
  }

  private openPopup = () => {
    //решили, что после нажатия на кнопку будем ставить куку непоказа анимации
    //иначе при текущей реализации с обновлением поиска после схранения кнопка начинает анимироваться
    setCookie('save_search_animation_done', 'rawr', {
      secure: false,
      expires: 60 * 24 * 30, // 30 дней
    });

    this.setState({
      isPopupVisible: true,
      isAnimated: false,
    });

    if (this.state.isSmallVersion) {
      trackingShowSaveOnNarrow();
    } else {
      trackingShowSaveOnWide();
    }

    if (this.props.isAdvancedFiltersOpened) {
      trackSaveButtonWithAdvancedFilterClick();
    } else {
      trackSaveButtonClick();
    }
  };

  private handlePopupClose = () => {
    this.setState({
      isPopupVisible: false,
    });
  };
}

export const SaveContainer = connect<
  Pick<ISaveProps, 'jsonQuery' | 'isAuthenticated' | 'resultsJsonQuery' | 'newbuildingGkButtonExperiment'>,
  Pick<ISaveProps, 'isAdvancedFiltersOpened'>
>((state: IAppState) => {
  const newbuildingGkButtonExperiment = isNewbuildingGkButtonExperiment(state);

  return {
    jsonQuery: state.filters.jsonQuery,
    isAuthenticated: state.user.isAuthenticated,
    resultsJsonQuery: state.results.jsonQuery,
    queryString: state.results.queryString,
    newbuildingGkButtonExperiment,
  };
})(Save);
